// extracted by mini-css-extract-plugin
export default {"main":"hI4qi","title":"VA2Ee","link":"IWSru"};